



























import Vue from "vue";
import {Component, Prop} from 'vue-property-decorator'
import SkuListItem from "./SkuListItem";
import {CashoutData, categoryTags, Sku} from "../models";

const MORE_COMING_SOON = ['AU'];

@Component({
    components: {
        SkuListItem
    }
})
export default class SkuList extends Vue {
    @Prop()
    cashoutData!: CashoutData;
    @Prop()
    skus!: Sku[];

    categoryTags = categoryTags;
    selectedCategoryTagCode: string = "";
    searchTerm: string = '';

    get getAvailableSkus(): Sku[] {
        // Filter by country
        let skus = this.skus.filter(sku => sku.countryTagCodes.includes(this.cashoutData.cashoutCountryCode));
        // Filter by category
        if (this.selectedCategoryTagCode) {
            skus = skus.filter(sku => {
                return sku.categoryTagCodes.includes(this.selectedCategoryTagCode)
            })
        }
        // Filter by search term
        if (this.searchTerm.length != 0) {
            skus = skus.filter(sku => sku.name.toLowerCase().includes(this.searchTerm.toLowerCase()))
        }
        return skus
    }

    get moreComingSoon(): boolean {
        return MORE_COMING_SOON.includes(this.cashoutData.cashoutCountryCode)
    }
}
